module.exports = __webpack_public_path__ + "img/1561840219.990319f3.jpg";